import PropTypes from 'prop-types';
import cn from 'classnames';

import { getMentionLabel, parseMentionText } from 'utlis/chatPrototype';

import styles from './styles.module.scss';

// A sent message, with "#id (title)" of a known new idea shown as the same finding button as in the input
export function UserMessageContent({ content, mentionOptions, onNavigate }) {
  return (
    <span>
      {parseMentionText(content, mentionOptions).map((segment, index) => (
        segment.type === 'mention'
          ? (
            <button
              key={index}
              type="button"
              className={cn(styles['feedback-reference-button'], styles['user-message-chip'])}
              aria-label={`Open ${getMentionLabel(segment.option)} finding`}
              onClick={() => onNavigate?.(segment.option.insightUuid)}
            >
              {getMentionLabel(segment.option)}
            </button>
          )
          : segment.value
      ))}
    </span>
  );
}

UserMessageContent.propTypes = {
  content: PropTypes.string,
  mentionOptions: PropTypes.array,
  onNavigate: PropTypes.func,
};

UserMessageContent.defaultProps = {
  content: '',
  mentionOptions: [],
  onNavigate: undefined,
};
